var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 40,
    viewBox: "0 0 169 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.479 19.9399C3.27816 20.6767 7.43378 23.0418 9.66309 26.6086C12.4497 31.067 18.4408 35.9435 22.2026 26.6086C25.2121 19.1406 27.5234 16.5638 28.6117 15.0444C29.8525 13.312 33.8225 9.08118 39.0612 16.4377C44.2999 23.7941 46.074 26.2835 46.3062 26.6086C49.2879 30.208 51.3499 30.3146 56.4771 24.5186C62.8862 17.2736 65.8121 18.3882 69.2952 23.404C72.0818 27.4166 75.2863 33.2498 76.5403 35.6648C77.8871 38.1727 81.4167 41.0428 84.7606 32.4603C88.1044 23.8777 90.7052 12.1649 91.5876 7.38137C93.1202 3.19518 97.3836 -2.66548 102.176 7.38137C108.168 19.9399 111.511 22.4287 116.527 20.7568C121.543 19.0848 129.067 13.7904 133.386 25.3546C137.705 36.9187 144.393 45.8358 152.474 26.6086C158.938 11.2268 165.199 13.4189 167.521 16.4377",
    stroke: "#EF0000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.eb78875a5e332feb794915cfdda58679.svg";
export { ForwardRef as ReactComponent };